import { Grid2 } from "@mui/material";
import { useEffect, useState } from "react";
import { TopSitesStyles } from ".";
import NoData from "../../../../GlobalComponents/NoData/NoData";
import { useSelector } from "react-redux";
import { Actions } from "../../../../redux/constants/actionTypes";
import { getStore } from "../../../../Utils/storeUtils";
import FormPopup from "../../../../GlobalComponents/FormPopup/FormPopup";
import { blockIfSiteDeleting } from "../../../../Utils/activatePopup";
//icons
import { ReactComponent as Clonesite } from "../../../../GlobalAssets/svg/clonesite12.svg";

function TopSites(props) {
  const { sites, onClick, orgId, navigate } = props;

  const [popup, setPopup] = useState({
    popupState: false,
    popupType: "",
    popupTitle: "",
    popupSubtitle: "",
    popupButton: false,
    popupCancel: false,
    popupButtonTitle: "",
    popupCancelTitle: "",
    popupButtonFunction: () => {},
    popupCancelFunction: () => {},
  });

  useEffect(() => {
    if (sites?.length > 0) {
      sites.forEach((site) => {
        getStore().dispatch({
          type: Actions.API_SITES_LB_ARN,
          data: {
            siteName: site.siteName,
            siteId: site.siteId,
          },
        });
      });
    }
  }, [sites]);

  const statusLb = useSelector((state) => state.sitesInfo?.siteArns ?? {});

  const getSiteStatus = (siteId) => {
    return statusLb[siteId] === true ? "Available" : "Site Down";
  };

  const getStatusStyle = (siteStatus) => {
    return siteStatus === "Available"
      ? TopSitesStyles.activeStatus
      : TopSitesStyles.siteDown;
  };

  return (
    <Grid2 className={TopSitesStyles.container}>
      <Grid2 className={TopSitesStyles.label}>Top Performing Sites</Grid2>
      {sites?.length > 0 ? (
        <>
          {sites.map((site, index) => {
            const siteStatus = getSiteStatus(site.siteId);
            const liveEnv = site.environment.find((site) => site.LIVE);
            const devEnv = site.environment.find((site) => site.STAGING);

            const handleEnvironmentClick = (env) => {
              if (blockIfSiteDeleting(site, setPopup)) {
                return;
              }
              if (env === "STAGING") {
                navigate(
                  `/account/${orgId}/${site.siteId}/site-details?staging`
                );
              } else if (env === "LIVE") {
                navigate(`/account/${orgId}/${site.siteId}/site-details?live`);
              }
            };

            const handleDomainClick = (event) => {
              event.stopPropagation();
              if (blockIfSiteDeleting(site, setPopup)) {
                return;
              }
              window.open(
                `https://${site.domainName || site.siteName}.${
                  process.env.REACT_APP_TEMP_DOMAIN
                }`,
                "_blank"
              );
            };
            return (
              <Grid2
                key={index}
                className={`${
                  !devEnv ? TopSitesStyles.siteContainer : TopSitesStyles.isStg
                }`}
                onClick={() => {
                  if (blockIfSiteDeleting(site, setPopup)) {
                    return;
                  }
                  onClick(site);
                }}
              >
                <Grid2 className={TopSitesStyles.siteCard}>
                  <Grid2 className={TopSitesStyles.ImgSiteName}>
                    <Grid2 className={TopSitesStyles.siteImg}>
                      {site.imagePath !== null ? (
                        <img
                          src={site.imagePath}
                          className={TopSitesStyles.img}
                        />
                      ) : (
                        <Clonesite style={{ width: "76px", height: "48px" }} />
                      )}
                    </Grid2>
                    <Grid2>
                      <Grid2 className={TopSitesStyles.downFlexBox}>
                        <Grid2 className={TopSitesStyles.siteName}>
                          {site.siteName}
                        </Grid2>
                        <Grid2
                          className={`${
                            TopSitesStyles.siteStatus
                          } ${getStatusStyle(siteStatus)}`}
                        >
                          {siteStatus}
                        </Grid2>
                      </Grid2>
                      <Grid2
                        className={TopSitesStyles.siteDomain}
                        onClick={(event) => handleDomainClick(event)}
                      >
                        {`${site.domainName || site.siteName}.${
                          process.env.REACT_APP_TEMP_DOMAIN
                        }`}
                      </Grid2>
                    </Grid2>
                  </Grid2>
                </Grid2>
                <Grid2 className={TopSitesStyles.marginLeft}>
                  {devEnv && (
                    <Grid2
                      className={TopSitesStyles.devBox}
                      onClick={(e) => {
                        e.stopPropagation();
                        handleEnvironmentClick("STAGING");
                      }}
                    >
                      Stg
                    </Grid2>
                  )}
                  {liveEnv && (
                    <Grid2
                      className={TopSitesStyles.prodBox}
                      onClick={(e) => {
                        e.stopPropagation();
                        handleEnvironmentClick("LIVE");
                      }}
                    >
                      Prod
                    </Grid2>
                  )}
                </Grid2>
              </Grid2>
            );
          })}
        </>
      ) : (
        <NoData message={"No Sites"} style={{ marginTop: "100px" }} />
      )}
      <FormPopup
        trigger={popup.popupState}
        setTrigger={setPopup}
        type={popup.popupType}
        title={popup.popupTitle}
        subtitle={popup.popupSubtitle}
        button={popup.popupButton}
        cancel={popup.popupCancel}
        buttonTitle={popup.popupButtonTitle}
        buttonFunction={popup.popupButtonFunction}
        cancelTitle={popup.popupCancelTitle}
        cancelFunction={popup.popupCancelFunction}
      />
    </Grid2>
  );
}

export default TopSites;
